import {
    LIST_PERSON_TYPES,
    LIST_PERSON_TYPES_SUCCESS,
    LIST_PERSON_TYPES_ERROR,
    ADD_PERSON_TYPES,
    SAVE_PERSON_TYPES,
    SAVE_PERSON_TYPES_SUCCESS,
    SAVE_PERSON_TYPES_ERROR,
    DELETE_PERSON_TYPES,
    DELETE_PERSON_TYPES_SUCCESS,
    DELETE_PERSON_TYPES_ERROR,
    EDIT_PERSON_TYPES,
    UPDATE_PERSON_TYPES,
    UPDATE_PERSON_TYPES_SUCCESS,
    UPDATE_PERSON_TYPES_ERROR
} from '../types';

import clienteAxios from '../config/axios';
import authToken from '../config/token';

import personTypesData from '../data/personTypes';
import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';
import { METHOD_DISABLED } from '../constants/requestMethods';

const controller = 'persona-tipo';

//LISTAR PERSON TYPES
export function listPersonTypesAction(params) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listPersonTypes() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.get(`/${controller}`, { params });
            //Obtengo los datos
            const personTypes = response.data;
            //Llamo al dispatch
            dispatch( listPersonTypesSuccess(personTypes.content) );
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( listPersonTypesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const listPersonTypes = () => ({
    type: LIST_PERSON_TYPES,
    payload: true
});

const listPersonTypesSuccess = personTypes => ({
    type: LIST_PERSON_TYPES_SUCCESS,
    payload: personTypes
});

const listPersonTypesError = error => ({
    type: LIST_PERSON_TYPES_ERROR,
    payload: error
});

//ADD PERSON TYPE
export function addPersonTypesAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addPersonTypes(false) );
        //Abro el formulario
        showForm();
    }
}

const addPersonTypes = isEdit => ({
    type: ADD_PERSON_TYPES,
    payload: isEdit
});

//SAVE PERSON TYPE
export function savePersonTypesAction(personType, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( savePersonTypes() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, personType);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( savePersonTypesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( savePersonTypesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const savePersonTypes = () => ({
    type: SAVE_PERSON_TYPES,
    payload: true
});


const savePersonTypesSuccess = personType => ({
    type: SAVE_PERSON_TYPES_SUCCESS,
    payload: personType
});

const savePersonTypesError = error => ({
    type: SAVE_PERSON_TYPES_ERROR,
    payload: error
});

//EDIT PERSON TYPE
export function editPersonTypesAction(personType, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editPersonTypes(personType) );
        //Abro el formulario
        showForm();
    }
}

const editPersonTypes = personType => ({
    type: EDIT_PERSON_TYPES,
    payload: personType
});

//UPDATE PERSON TYPE
export function updatePersonTypesAction(personType, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updatePersonTypes() );
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${personType.id}`, personType);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( updatePersonTypesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updatePersonTypesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updatePersonTypes = () => ({
    type: UPDATE_PERSON_TYPES,
    payload: true
});

const updatePersonTypesSuccess = personType => ({
    type: UPDATE_PERSON_TYPES_SUCCESS,
    payload: personType
});

const updatePersonTypesError = error => ({
    type: UPDATE_PERSON_TYPES_ERROR,
    payload: error
});

//DELETE PERSON TYPE
export function deletePersonTypesAction(personType) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deletePersonTypes() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try{
            //Busco el token de cliente
            //const token = process.env.REACT_APP_CLIENT_TOKEN;
            //Lo agrego para la consulta
            //authToken(token);
            //Hago la consulta
            // const response = await clienteAxios.delete(`/${controller}/${personType.id}`);
            const response = await clienteAxios.put(`/${controller}/${personType.id}/${METHOD_DISABLED}`);
            //Obtengo los datos
            //const res = response.data;
            //Llamo al dispatch
            dispatch( deletePersonTypesSuccess(response.data) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( deletePersonTypesError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const deletePersonTypes = () => ({
    type: DELETE_PERSON_TYPES,
    payload: true
});

const deletePersonTypesSuccess = personType => ({
    type: DELETE_PERSON_TYPES_SUCCESS,
    payload: personType
});

const deletePersonTypesError = error => ({
    type: DELETE_PERSON_TYPES_ERROR,
    payload: error
});